var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"term-box"},[(_vm.detialInfo)?_c('div',{staticClass:"paragraph",domProps:{"innerHTML":_vm._s(_vm.formatBr(_vm.detialInfo.acceptCondition))}}):_c('van-empty',{attrs:{"description":"暂无数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }